import { render, staticRenderFns } from "./MeatProductionCost.vue?vue&type=template&id=1b011de6&scoped=true"
import script from "./MeatProductionCost.vue?vue&type=script&lang=js"
export * from "./MeatProductionCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b011de6",
  null
  
)

export default component.exports